const parseTypes = {
  date: 0,
  dateTime: 1,
  number: 2,
  numberArray: 3,
  string: 4,
  stringArray: 5
};

const __prod__ = process.env.REACT_APP_ENV === 'production';
const __dev__ = ['staging'].includes(process.env.REACT_APP_ENV);
const __local__ = ['development'].includes(process.env.REACT_APP_ENV);

const isDev = __dev__ || __local__;

export {
  __dev__,
  __prod__,
  __local__,
  parseTypes,
  isDev
};
